window.abortControllerMap = {}
export function cancelRequestByKey(key: string | number) {
  if (key == null) return
  const targetController = window.abortControllerMap[key]

  if (Array.isArray(targetController)) {
    targetController.forEach((item) => {
      item?.abort()
    })
    return
  } else {
    targetController?.abort()
  }
}

export function cancelAllRequest() {
  for (const key in window.abortControllerMap) {
    const item = window.abortControllerMap[key]
    // support array
    if (Array.isArray(item)) {
      item.forEach((i) => {
        i?.abort()
      })
    } else {
      item?.abort()
    }
  }
}

export function saveRequestByKey(key: string | number, controller: AbortController) {
  if (!window.abortControllerMap) {
    window.abortControllerMap = {}
  }

  const targetController = window.abortControllerMap[key]
  // support array
  if (Array.isArray(targetController)) {
    targetController.push(controller)
    return
  }
  window.abortControllerMap[key] = [controller]
}
